const slice = 'product';

export const ADD_PRODUCT = `${slice}/addProduct`;
export const INCREASE_PRODUCT_QTY = `${slice}/increaseQuantity`;
export const DECREASE_PRODUCT_QTY = `${slice}/decreaseQuantity`;

export const RESTORE_PRODUCT_QTY = `${slice}/restoreQuantity`;